// just a few util functions that we need to load before the rest of the marionette app
// keep in _gp_utils global object to avoid namespace issues


window._gp_utils = {

    // Backbone.Model.set override that will look for "attr_types" property in the model object (user defined)
    // which should be an object of {attribute_name: var_type} that should be checked and set correct type
    // attr_types object can be nested 1 level like so {name: type, name: {sub_name: type}}
    // bbm = back bone model
    bbm_ensure_types: function(attr, options) {
        var attr_types = this.attr_types;

        if (!_.isEmpty(attr) && !_.isEmpty(attr_types) && _.isObject(attr_types)) {
            $.each(attr_types, function(key, var_type) {
                // if attr is a string, then it was a set for a single attribute i.e. model.set('attr', 'val')
                if (_.isString(attr) && attr == key) {
                    options = _gp_utils.convert_attr_type(options, var_type);
                    return false; // breaks out of jQuery.each loop
                }
                // if attr is an object, model.set() was called with an object of values i.e. model.set({attr: 'val'})
                else if (_.isObject(attr)) {
                    if (attr.hasOwnProperty(key)) {
                        if (_.isObject(var_type)) {
                            $.each(var_type, function(sub_key, sub_type) {
                                if (attr[key].hasOwnProperty(sub_key)) {
                                    attr[key][sub_key] = _gp_utils.convert_attr_type(attr[key][sub_key], sub_type);
                                }
                            });
                        } else {
                            attr[key] = _gp_utils.convert_attr_type(attr[key], var_type);
                        }
                    }
                }
            });
        }
        Backbone.Model.prototype.set.call(this, attr, options);
    },
    // helper function to parse variable against specific types (int, bool etc...)
    convert_attr_type: function(val, attr_type) {
        if (typeof val != 'undefined' && typeof attr_type != 'undefined') {
            switch (attr_type) {
                case 'int':
                    var tmp_int = parseInt(val, 10);
                    if (_.isFinite(tmp_int)) {
                        val = tmp_int;
                    }
                    break;

                case 'bool':
                    if (_.isString(val)) {
                        var tmp_val = val.toLowerCase();
                        val = ((_.isEmpty(tmp_val) || $.inArray(tmp_val, ['false', '0']) !== -1) ? false : true);
                    } else {
                        val = !!val;
                    }
                    break;

                // case: 'other_type':
                //     // TODO: add more types here
                //     break;

                default:
                    // no attr_type matched (might want to do something here, but probably not)
                    break;
            }
        }
        return val;
    }
};
